import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media(max-width: 900px)': {
      flexDirection: 'column',
      gap: '10px',
    },
  },

  clockContainer: {
    // position: 'relative',
    width: '280px',
    height: '280px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  hourSymbol: {
    position: 'absolute',
    fontSize: '32px',
    width: '56px',
    height: '52px',
    textAlign: 'center',
    userSelect: 'none',
  },

  selected: {
    color: 'white',
    borderRadius: '100%',
    backgroundColor: '#102131',
  },

  arrow: {
    height: '56px',
    width: '2px',
    borderRadius: '0.5px',
    backgroundColor: '#102131',
    position: 'relative',
    top: '26px',
    transformOrigin: '0% 0%',
    transition: 'transform 1.0s',

    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '-3px',
      top: '-3px',
      borderRadius: '100%',
      width: '8px',
      height: '8px',
      backgroundColor: '#102131',
    },
  },

  hoverable: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(16,33,49, 0.08)',
      borderRadius: '100%',
    },
  },

  amDiv: {
    padding: '8px',
    textAlign: 'center',
    userSelect: 'none',
    backgroundColor: 'rgba(16,33,49, 0.08)',
    position: 'relative',
    left: '72px',
    '& span': {
      fontSize: '32px',
      textTransform: 'uppercase',
    },
    '@media(max-width: 900px)': {
      left: 0,
    },
  },
});
